<template>
  <span>{{ formattedDate }}</span>
</template>

<script>
export default {
  name: "dataFormatter",
  props: {
    date: [Number, String],
    input: {
      default: "datetime",
      type: String,
    },
    output: {
      default: "date",
      type: String,
    },
  },
  data: () => ({
    formattedDate: null,
    format: null,
  }),
  mounted() {
    // Output
    switch (this.output) {
      case "date":
        this.format = "L";
        break;

      default:
        this.format = "L";
    }

    // Input
    switch (this.input) {
      case "datetime":
        this.formattedDate = this.utcToLocalDate();
        break;

      case "timestamp":
        this.formattedDate = this.timestampToLocalDate();
        break;

      default:
        console.log("Wrong input type!");
    }
  },
  methods: {
    utcToLocalDate() {
      return this.$moment(this.date)
        .locale(this.$store.getters.locale)
        .tz(this.$store.getters.timezone)
        .format(this.format);
    },
    timestampToLocalDate() {
      return this.$moment
        .unix(this.date)
        .locale(this.$store.getters.locale)
        .tz(this.$store.getters.timezone)
        .format(this.format);
    },
  },
};
</script>